import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import * as commonDate from 'libs/commonDate';

import { IMmbrItemsState, IUsr0302P2State, IPjDevItemState, IPjRoleItemState } from '../../models/usr/usr0302p2_model';

const initialState: IUsr0302P2State = {

    // 공통코드
    pjRoleList : [], // 역할
    pjDevList  : [], // 개발유형

    // 경력등록
    mmbrItems : {
        pjStartDt     : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD'), // 프로젝트 시작일자
        pjEndDt       : commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD'), // 프로젝트 종료일자
        pjNm          : '', // 프로젝트명
        cusNm         : '', // 고객사
        pjDevBizCntnt : '', // 업무
        pjDevRoleCd   : '', // 역할
        pjDevtoolView : '', // 개발툴 및 언어(화면)
        pjDevtoolSvc  : '', // 개발툴 및 언어(서비스)
        pjDevtoolDb   : '', // 개발 DB
        pjDevtoolRpt  : '', // 사용 REPORT
        pjDevformType : '', // 개발형태
        pjDevTypeCd   : '', // 개발유형
    },

}

export const usr0302p2_Slice = createSlice({
    name: "usr0302p2_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
                    Object.assign(state, {
                        ...initialState
                        , pjDevList: state.pjDevList
                        , pjRoleList: state.pjRoleList
                    });
                },
        setPjRoleList: (state, action:PayloadAction<IPjRoleItemState[]>) => {
            state.pjRoleList = action.payload;
        },
        setPjDevList: (state, action:PayloadAction<IPjDevItemState[]>) => {
            state.pjDevList = action.payload;
        },
        setMmbrItems: (state, action:PayloadAction<IMmbrItemsState>) => {
            state.mmbrItems = action.payload;
        },
    },
});

export default usr0302p2_Slice.reducer;
export const Usr0302p2Action  = usr0302p2_Slice.actions;
export const Usr0302p2Reducer = usr0302p2_Slice.reducer;